@if (appFacadeService.isDialogDisplayed() | async) { @if ((appFacadeService.getDialogContentType() | async) === dialogContentType.RequestSentSuccessfully) {
<por-app-confirm-dialog (confirmed)="appFacadeService.toggleDialog(false)" [message]="message">
    <p>{{ 'YourRequestHasBeenSentTo' | translate }} {{ (appFacadeService.getConfig() | async)?.storeName }}</p>
</por-app-confirm-dialog>
} }
